module.exports = __webpack_public_path__ + "static/media/grp-1.540d7b09.png";